import { render, staticRenderFns } from "./SectionMenu.vue?vue&type=template&id=171c8684&scoped=true&"
import script from "./SectionMenu.vue?vue&type=script&lang=ts&"
export * from "./SectionMenu.vue?vue&type=script&lang=ts&"
import style0 from "./SectionMenu.vue?vue&type=style&index=0&id=171c8684&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171c8684",
  null
  
)

export default component.exports